/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConciergeDataset } from './ConciergeDataset';
import { ConciergeDatasetFromJSON, ConciergeDatasetFromJSONTyped, ConciergeDatasetToJSON } from './ConciergeDataset';

/**
 *
 * @export
 * @interface PaginatedConciergeDatasetList
 */
export interface PaginatedConciergeDatasetList {
  /**
   *
   * @type {number}
   * @memberof PaginatedConciergeDatasetList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedConciergeDatasetList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedConciergeDatasetList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<ConciergeDataset>}
   * @memberof PaginatedConciergeDatasetList
   */
  results: Array<ConciergeDataset>;
}

/**
 * Check if a given object implements the PaginatedConciergeDatasetList interface.
 */
export function instanceOfPaginatedConciergeDatasetList(value: object): value is PaginatedConciergeDatasetList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedConciergeDatasetListFromJSON(json: any): PaginatedConciergeDatasetList {
  return PaginatedConciergeDatasetListFromJSONTyped(json, false);
}

export function PaginatedConciergeDatasetListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedConciergeDatasetList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(ConciergeDatasetFromJSON),
  };
}

export function PaginatedConciergeDatasetListToJSON(value?: PaginatedConciergeDatasetList | null): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(ConciergeDatasetToJSON),
  };
}
